import { closeModal } from 'components/modal/modules/dispatcher/methods';
import React from 'react'
import { fetchGraphQL } from 'services/graphql/GraphQL';

export default class EndSalesModal extends React.Component<{ [label: string]: any }, { [label: string]: any }> {
    constructor(props) {
        super(props)
        this.endSales = this.endSales.bind(this);
    }

    public endSales() {
        const arr: string[] = [];
        this.props.ticketInventory.map((item: any) => {
            arr.push(item!._id)
        })

        fetchGraphQL(
            `
        mutation {
            ticket {
                endSales(eventId:"${this.props.eventId}", ticketBankIds:"${arr}")
            }
        }
        `
        ).then(res => {
            closeModal();
            window.location.reload();
        })
    }

    public render() {
        return <div>
            All available tickets will be cleared and all offers pending purchase will be voided.<br />
            Promoters will no longer be able to create offers and customers will not
            be able to purchase tickets.
                <br /><br />
            <div style={{ width: "100%" }}>
                <div className="Seperate-Buttons">

                    <button
                        className='new-button-white-3'
                        style={{ border: 'none', cursor: 'pointer' }}
                        onClick={e => closeModal()}
                    >
                        CANCEL
                    </button>

                    <button
                        className="new-button-red-3"
                        style={{ border: 'none', cursor: 'pointer' }}
                        onClick={this.endSales}
                    >
                        END SALES
                    </button>

                </div>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/pages/manage/events/detail/EndSalesModal.tsx